import ItemActions from './ItemActions'

module.exports = ItemActions.create( { 
  parentName : 'project', 
  itemsName : 'accounts', 
  actionTypeBase : 'PROJECT_ACCOUNT', 
  parentIdKey : 'projectId', 
  humanItemName : 'Account',
  totalKey : 'total',
} )
